import config from 'config';
import dayjs from 'dayjs';
import * as storageLocale from 'i18n/storageLocale';

const getCustomHeaders = () => ({
  'Accept-Language': storageLocale.getLocale(),
  ...(config.territory && { territory: config.territory }),
  'Browser-Time': dayjs().format('YYYY-MM-DDTHH:mm:ssZ'),
});

export default getCustomHeaders;
